import React from 'react';

import styles from './styles.scss';

const RateCard = ({
  title,
  options = [],
  price,
  discount,
  altPrice
 }) => <div className={styles.RateCard}>
   {discount && <div className={styles.Discount}>-{discount}</div>}
   <div className={styles.RateCardTitle}>{title}</div>
   <div>
     <div className={styles.RateCardInclude}>Включено в тариф</div>
     {options !== undefined && options.length > 0 && (
       <ul className={styles.RateCardList}>
         {options.map(option => <li key={option}>{option}</li>)}
       </ul>
     )}
   </div>
   <div className={styles.RateCardPrice}>
     {price} {altPrice && <span className={styles.AltPrice}>{altPrice}</span>}
   </div>
 </div>;

export default React.memo(RateCard);



// WEBPACK FOOTER //
// ./src/containers/Rates/RateCard/index.js